import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import CommentPost from 'flarum/forum/components/CommentPost';
import TextEditor from 'flarum/common/components/TextEditor';
import Button from 'flarum/common/components/Button';
import LineupModal from './components/LineupModal';
import LineupPitch from './components/LineupPitch';
app.initializers.add('ois-lineup', () => {
  // Add toolbar button to composer
  extend(TextEditor.prototype, 'toolbarItems', function (items) {
    const editor = this;
    items.add('ois-lineup', m(Button, {
      icon: 'fas fa-futbol',
      className: 'Button Button--icon Button--link',
      title: app.translator.trans('ois-lineup.forum.composer_button'),
      onclick: () => {
        app.modal.show(LineupModal, {
          onsubmit: bbcode => {
            editor.attrs.composer.editor.insertAtCursor(bbcode);
          }
        });
      }
    }));
  });

  // Hydrate lineup divs in posts
  function hydrateLineups(element) {
    element.querySelectorAll('.ois-lineup:not([data-rendered])').forEach(el => {
      el.setAttribute('data-rendered', '1');
      const formation = el.dataset.formation;
      const players = el.textContent;
      el.textContent = '';
      m.mount(el, {
        view: () => m(LineupPitch, {
          formation,
          players
        })
      });
    });
  }
  extend(CommentPost.prototype, 'oncreate', function () {
    hydrateLineups(this.element);
  });
  extend(CommentPost.prototype, 'onupdate', function () {
    hydrateLineups(this.element);
  });
});